import { AuthenticationConfiguration } from '../configuration/authentication_configuration';
import { MemberConfigurationDatastore } from '../datastore/member_configuration_datastore';

export class URLQueryModel {
  constructor(
    private $injector: any,
    private authenticationConfiguration: AuthenticationConfiguration,
    private ngMemberConfigurationDatastore: MemberConfigurationDatastore
  ) {}
  getLoginUrl() {
    return (
      this.authenticationConfiguration.read().authenticationApiPrefix +
      this.ngMemberConfigurationDatastore.read((store: any) => store.login_url)
    );
  }

  getLogoutUrl() {
    return (
      this.authenticationConfiguration.read().authenticationApiPrefix +
      this.ngMemberConfigurationDatastore.read((store: any) => store.logout_url)
    );
  }

  getLoginConfigurationUrl() {
    const c = this.authenticationConfiguration.read();
    return c ? c.authenticationApiPrefix + 'login' : '';
  }

  getLogoutRequestMethod() {
    return this.ngMemberConfigurationDatastore.store.auth_type.logoutMethod;
  }

  getAccountUrl() {
    return this.authenticationConfiguration.read().authenticationApiPrefix + 'account';
  }
  /**
   * will transition to state, if it exists
   */
  transitionToLogoutState() {
    const goToStateOnLogout: string = this.authenticationConfiguration.read().goToStateOnLogout;
    const state: ng.ui.IStateService = this.$injector.get('$state');
    if (state && state.get(goToStateOnLogout) !== null) {
      state.go(goToStateOnLogout, {}, { location: 'replace' });
    }
  }
}
angular
  .module('data-ng-authentication')
  .factory(
    'ngURLQueryModel',
    (
      $injector: any,
      authenticationConfiguration: AuthenticationConfiguration,
      ngMemberConfigurationDatastore: MemberConfigurationDatastore
    ) => new URLQueryModel($injector, authenticationConfiguration, ngMemberConfigurationDatastore)
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/queries/url_query_model.ts